<!--
  app/components/pages/how-to-play/HtpIconMatchball.vue
-->
<script setup lang="ts">
defineProps<{ width?: number; height?: number }>();
</script>

<template>
  <svg
    :width="width ?? 44"
    :height="height ?? 44"
    viewBox="0 0 107 107"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M53.1339 0C23.8324 0 0 23.8324 0 53.1339C0 82.4353 23.8324 106.268 53.1339 106.268C82.4353 106.268 106.268 82.4353 106.268 53.1339C106.268 23.8324 82.3991 0 53.1339 0ZM65.3036 101.052C64.543 100.762 63.8186 100.436 63.1304 100.002H63.2391C61.0659 98.553 59.6896 96.2349 58.8565 93.4098C58.7479 93.0838 58.4581 92.8665 58.1321 92.8665H48.208C47.882 92.8665 47.5923 93.0838 47.4836 93.4098C46.6506 96.2349 45.2742 98.553 43.1011 100.002C42.4129 100.473 41.6885 100.799 40.9279 101.052C19.7758 95.6916 3.98413 76.6765 3.62194 53.9307C4.38255 50.7434 5.90376 48.1356 8.25802 46.5057C11.7351 44.1514 16.4798 44.3325 21.3694 46.5057C21.7316 46.6506 22.1663 46.5057 22.3474 46.1797L27.9614 35.0966C28.1062 34.7706 28.0338 34.4084 27.7803 34.1911C23.941 31.0038 21.623 27.1645 21.623 22.8182C21.623 16.6609 26.4764 11.1556 33.9376 7.46119C39.8413 4.99828 46.2884 3.62194 53.0614 3.62194C59.8344 3.62194 65.702 4.88962 71.3884 7.17144C72.1128 7.4612 72.8372 7.78717 73.5616 8.11314C73.7427 8.18558 73.9238 8.29424 74.1049 8.36668C80.6244 11.9524 84.7896 17.1318 84.7896 22.9269C84.7896 27.0559 82.6527 30.7865 79.1032 33.8651C78.8496 34.0825 78.7772 34.4809 78.9221 34.7706L84.6809 45.9986C84.862 46.3246 85.2605 46.5057 85.6226 46.3608C90.4036 44.4774 94.8586 44.3688 98.1546 46.6144C100.364 48.0994 101.813 50.4174 102.61 53.3149C102.537 76.3143 86.6368 95.6192 65.3036 101.052ZM76.3143 51.504C76.4591 51.7937 76.3867 52.1921 76.1332 52.4095C72.6561 55.4157 69.2153 59.0738 66.3177 63.565C62.2611 69.8672 59.762 76.278 58.7116 82.1456C58.6392 82.5078 58.3494 82.7613 57.9873 82.7613H48.4978C48.1356 82.7613 47.8458 82.5078 47.7734 82.1456C46.723 76.278 44.2239 69.7948 40.1673 63.565C37.3784 59.2549 34.2273 55.7054 30.9676 52.8079C30.714 52.5906 30.6416 52.2284 30.7865 51.9024L36.8713 40.0224C37.0524 39.6965 37.4146 39.5516 37.7768 39.6602C42.3405 41.2539 47.375 42.1956 53.3149 42.1956C59.2549 42.1956 64.7603 41.1814 69.4688 39.4791C69.831 39.3343 70.2294 39.4791 70.3743 39.8413L76.3505 51.504H76.3143Z"
      fill="url(#matchball_gold_gradient)"
    />
    <defs>
      <linearGradient
        id="matchball_gold_gradient"
        x1="26.0938"
        y1="-14.8922"
        x2="58.2524"
        y2="120.216"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.175219" stop-color="#7E5B0E" />
        <stop offset="0.492935" stop-color="#C2AC7B" />
        <stop offset="0.571061" stop-color="#FFF2D5" />
        <stop offset="0.607521" stop-color="#FCD786" />
        <stop offset="1" stop-color="#3B2B08" />
      </linearGradient>
    </defs>
  </svg>
</template>
